import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import './AuditTrail.css';

const AuditTrail = ({ auditTrail }) => {
  return (
    <Box className="td-audit-section card">
      <Typography variant="h6" className="td-audit-title">
        Audit Trail
      </Typography>
      {auditTrail && auditTrail.length > 0 ? (
        <ul className="td-timeline">
          {auditTrail.map((entry) => (
            <li key={entry.id} className="td-timeline-item">
              <Box className="td-timeline-separator">
                <span className="td-timeline-dot"></span>
                <span className="td-timeline-connector"></span>
              </Box>
              <Box className="td-timeline-content">
                <span className="td-timeline-event">{entry.event}</span>
                <span className="td-timeline-details text-secondary">{`${entry.date} by ${entry.user}`}</span>
              </Box>
            </li>
          ))}
        </ul>
      ) : (
        <span className="td-audit-placeholder text-secondary">No audit trail entries found.</span>
      )}
    </Box>
  );
};

// PropTypes for type checking
AuditTrail.propTypes = {
  auditTrail: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      event: PropTypes.string.isRequired,
      date: PropTypes.string.isRequired,
      user: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default AuditTrail;